import { render, staticRenderFns } from "./CardTecnicoProdutorFazenda.vue?vue&type=template&id=3432fa94"
import script from "./CardTecnicoProdutorFazenda.vue?vue&type=script&lang=js"
export * from "./CardTecnicoProdutorFazenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports